import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Agents admin roster (CLAUDE.md §2.3),
 * mirroring the HRM/CRM/LMS list stores (see `hrm/employees/store/viewPrefs`).
 * Agents' only grouping dimension is `direction`, so there is no
 * `grouped_dept`-style second grouping. Default is `grouped` — the roster reads
 * best broken out by business direction.
 */
export type AgentsViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const AGENTS_VIEW_MODES: AgentsViewMode[] = ['table', 'list', 'cards', 'grouped'];

interface AgentsUiState {
  view: AgentsViewMode;
  setView: (view: AgentsViewMode) => void;
}

export const useAgentsUi = create<AgentsUiState>()(
  persist(
    (set) => ({
      view: 'grouped',
      setView: (view) => set({ view }),
    }),
    {
      name: 'agents.admin:ui',
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
